module.exports = __webpack_public_path__ + "static/media/instantfirming.0cafe659.svg";